import { useState } from "react";
import AppLayout from "@/components/AppLayout";
import { ClientSidebar } from "@/components/sidebars";
import { useAuth } from "@/lib/auth";
import { apiClient, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

const TIPOS = [
  { id: "grua",       label: "Grúa / Servicio vial", icon: "fas fa-truck-pickup" },
  { id: "medica",     label: "Servicio médico telefónico", icon: "fas fa-stethoscope" },
  { id: "ambulancia", label: "Envío de ambulancia",    icon: "fas fa-ambulance" },
  { id: "legal",      label: "Servicio legal",       icon: "fas fa-gavel" },
];

export default function SolicitarAsistencia() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const beneficiarios = user?.beneficiarios || [];
  const [tipo, setTipo] = useState("grua");
  const [beneficiario_index, setBenefIdx] = useState(0);
  const [descripcion, setDesc] = useState("");
  const [ubicacion, setUbic] = useState("");
  const [telefono_contacto, setTel] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiClient.post("/solicitudes", { tipo, beneficiario_index, descripcion, ubicacion, telefono_contacto });
      toast.success("Solicitud enviada. Te contactaremos de inmediato.");
      navigate("/cuenta/historial");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppLayout sidebar={ClientSidebar}>
      <header className="app-header">
        <h1>Solicitar Servicio</h1>
        <p className="text-muted">Activa el servicio para tu familiar en México. Respondemos en minutos.</p>
      </header>

      {user?.membership_status !== "active" && (
        <div className="alert-card"><i className="fas fa-exclamation-triangle" />
          <div><strong>Tu membresía no está activa.</strong>
            <p>Activa un plan para poder solicitar servicio.</p></div>
        </div>
      )}

      {beneficiarios.length === 0 ? (
        <div className="panel"><p>Primero agrega beneficiarios.</p></div>
      ) : (
        <form onSubmit={submit} className="panel">
          <h3>1. Tipo de servicio</h3>
          <div className="tipo-grid">
            {TIPOS.map((t) => (
              <button type="button" key={t.id} onClick={() => setTipo(t.id)}
                className={`tipo-btn ${tipo === t.id ? "active" : ""}`} data-testid={`tipo-${t.id}`}>
                <i className={t.icon} />{t.label}
              </button>
            ))}
          </div>

          <h3>2. Beneficiario</h3>
          <div className="form-group">
            <select value={beneficiario_index} onChange={(e) => setBenefIdx(Number(e.target.value))} data-testid="sol-benef">
              {beneficiarios.map((b, i) => (
                <option key={i} value={i}>{b.nombre} — {b.relacion} ({b.municipio}, {b.estado})</option>
              ))}
            </select>
          </div>

          <h3>3. Detalles</h3>
          <div className="form-group"><label>Descripción del problema *</label>
            <textarea required rows={4} value={descripcion} onChange={(e) => setDesc(e.target.value)} placeholder="Ej. mi mamá tiene fiebre alta y no responde bien" data-testid="sol-desc" />
          </div>
          <div className="form-grid-2">
            <div className="form-group"><label>Ubicación actual (si difiere del domicilio)</label>
              <input type="text" value={ubicacion} onChange={(e) => setUbic(e.target.value)} placeholder="Carretera, km, calle, etc." data-testid="sol-ubic" /></div>
            <div className="form-group"><label>Teléfono de contacto inmediato</label>
              <input type="tel" value={telefono_contacto} onChange={(e) => setTel(e.target.value)} placeholder="Si es distinto al registrado" data-testid="sol-tel" /></div>
          </div>
          <button type="submit" disabled={loading} className="btn btn-primary btn-block" data-testid="sol-submit">
            {loading ? "Enviando..." : "Enviar solicitud"}
          </button>
        </form>
      )}
    </AppLayout>
  );
}
